import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import resources from '@resources';
import paths from '@paths';
import {Props} from './types';

export const submit = async (
  value: any,
  formikHelpers: FormikHelpers<any>,
  actions: UsersAction & MeAction,
  me: MeStore,
  props: Props
) => {
  try {
    const birthdate = resources.users.getBirthDate(
      value.birthyear,
      value.birthmonth,
      value.birthday
    );

    await actions.users.updateUser(
      {
        lastName: value.lastName,
        firstName: value.firstName,
        lastKana: value.lastKana,
        firstKana: value.firstKana,
        phoneNumber: value.phoneNumber,
        prefecture: value.prefecture,
        email: value.email,
        authLevel: value.authLevel,
        gender: value.gender,
        organization: value.organization,
        position: value.position,
        birthdate,
      },
      me.id,
      true
    );
    await actions.me.updateMe();
    notify(
      resources.users.getNotifyMessage('success', 'update', 'me'),
      'success'
    );
    props.history.push(paths.myPage.main);
  } catch (error) {
    notify(resources.users.getNotifyMessage('error', 'update', 'me'), 'error');
  } finally {
    formikHelpers.setSubmitting(false);
  }
};
